var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mt-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm.isError ? _c('b-row', {
    staticClass: "justify-content-center mt-2"
  }, [_c('b-col', {
    attrs: {
      "lg": "10"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": "",
      "dismissible": ""
    }
  }, [_vm._v(" Opps .. Something is wrong ")])], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-group row justify-content-center"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('b-form-select', {
    staticClass: "mb-2",
    attrs: {
      "id": "currency",
      "options": _vm.statusOptions,
      "required": ""
    },
    on: {
      "change": _vm.onStatusChange
    },
    model: {
      value: _vm.status,
      callback: function ($$v) {
        _vm.status = $$v;
      },
      expression: "status"
    }
  })], 1), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "type client name..."
    },
    on: {
      "input": _vm.debounceSearch
    }
  }), _vm.typing ? _c('span', [_c('em', [_vm._v(" searching... ")])]) : _vm._e()]), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('router-link', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "to": {
        path: '/client/create'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)]), _c('div', {
    staticClass: "row justify-content-end"
  }, [_c('label', {
    staticClass: "col-sm-auto",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Total : ")]), _c('strong', {
    staticClass: "col-sm-auto"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.totalRows)))])]), _c('b-table', {
    attrs: {
      "items": _vm.client,
      "fields": _vm.fields,
      "busy": _vm.isLoading,
      "isLoading": _vm.isLoading,
      "show-empty": "",
      "responsive": "",
      "hover": "",
      "sort-icon-left": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(No)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s((_vm.currentPage - 1) * _vm.perPage + (row.index + 1)) + ". ")];
      }
    }, {
      key: "cell(name)",
      fn: function (row) {
        return [_c('div', {
          staticStyle: {
            "width": "250px"
          }
        }, [_c('router-link', {
          attrs: {
            "to": {
              path: '/client/edit/' + row.item.id
            }
          }
        }, [_vm._v(" " + _vm._s(row.item.name) + " ")]), _c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" #" + _vm._s(row.item.client_id) + " ")])], 1)];
      }
    }, {
      key: "cell(app_name)",
      fn: function (row) {
        return [_c('div', {
          staticStyle: {
            "width": "200px"
          }
        }, [_vm._v(" " + _vm._s(row.item.app_name) + " ")])];
      }
    }, {
      key: "cell(allow_age_restricted_content)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(row.item.allow_age_restricted_content ? '✅' : '❌') + " ")];
      }
    }, {
      key: "cell(is_active)",
      fn: function (row) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_vm._v(" " + _vm._s(row.item.is_active ? '✅' : '❌') + " ")])];
      }
    }, {
      key: "cell(platform)",
      fn: function (row) {
        return [_c('Platform', {
          attrs: {
            "platform": row.item.platform_id
          }
        })];
      }
    }, {
      key: "cell(created)",
      fn: function (row) {
        return [_c('div', {
          staticStyle: {
            "width": "150px"
          }
        }, [_vm._v(" " + _vm._s(row.item.created ? _vm.formatDate(row.item.created) : '-') + " ")])];
      }
    }, {
      key: "cell(modified)",
      fn: function (row) {
        return [_c('div', {
          staticStyle: {
            "width": "150px"
          }
        }, [_vm._v(" " + _vm._s(row.item.modified ? _vm.formatDate(row.item.modified) : '-') + " ")])];
      }
    }, {
      key: "table-busy",
      fn: function () {
        return [_c('div', {
          staticClass: "text-center text-dark my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle",
          attrs: {
            "variant": "dark",
            "type": "grow",
            "label": "Loading .."
          }
        }), _vm._v(" Loading .. ")], 1)];
      },
      proxy: true
    }])
  })], 1), _c('b-row', {
    staticClass: "justify-content-start ml-1"
  }, [_c('b-col', {
    attrs: {
      "lg": "3"
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "aria-controls": "my-table"
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }